module.exports = __webpack_public_path__ + "img/9788925520339.d96e77da.jpg";